const partMatrix = (setup, transferBalanceCapAmountKnown) => {
  if (setup.howMuch === 'The whole balance of the pensioner\'s accumulation account') {
    if (setup.accumulationKnown === 'Yes') {
      return 'PART_2_FULL';
    }
    return 'PART_1';
  }
  if (setup.howMuch === 'The balance of the pensioner\'s accumulation account less a fixed amount') {
    if (setup.accumulationKnown === 'Yes') {
      return 'PART_2_FULL';
    }
    return 'PART_1';
  }
  if (setup.howMuch === 'As much as possible without going over the transfer balance cap') {
    if (setup.accumulationKnown === 'Yes') {
      if (transferBalanceCapAmountKnown === 'Yes') {
        return 'PART_2_FULL';
      }
      return 'PART_1';
    }
    if (setup.taxComponentKnown === 'Yes') {
      if (transferBalanceCapAmountKnown === 'Yes') {
        return 'PART_2_MINI';
      }
      return 'PART_1';
    }
  }
  if (setup.howMuch === 'A fixed amount') {
    if (setup.accumulationKnown === 'Yes') {
      return 'PART_2_FULL';
    }
    if (setup.taxComponentKnown === 'Yes') {
      return 'PART_2_MINI';
    }
    return 'PART_1';
  }

  return 'PART_1';
};

export default partMatrix;
